import apiClient from './apiClient';

export interface PublicSettings {
  maintenanceMode: boolean;
  maintenanceMessage: string;
  announcement: string;
  announcementActive: boolean;
  popupTitle: string;
  popupMessage: string;
  popupActive: boolean;
  popupType: 'info' | 'warning' | 'success' | 'promo';
  defaultNewUserPlan: 'daily' | 'weekly' | 'monthly' | null;
  adsEnabled: boolean;
  adsTargetMode: 'all' | 'specific_plans';
  adsTargetPlanTypes: string[];
  adsIncludeFreeUsers: boolean;
}

export const settingsApi = {
  getPublic: () => apiClient.get<{ success: boolean; data: PublicSettings }>('/settings'),
  requestDeletion: (password: string) => apiClient.post('/settings/request-deletion', { password }),
};
